










import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency";
import ReimburseMeBarChartNext from "@/employee/components/ReimburseMeBarChartNext.vue";
import PocReimburseMeBarChart from "@/employee/components/PocReimburseMeBarChart.vue";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useHsaDailyBalanceStore } from "@/shared/store/hsaDailyBalance";
import { useExpenseBalanceSummaryStore } from "@/employee/store/expenseBalanceSummary";

@Component({
  components: {
    PocReimburseMeBarChart
  }
})
export default class CashExpensesGraphWidget extends Vue {

  hsaDailyBalanceStore = useHsaDailyBalanceStore();
  expenseBalanceSummaryStore = useExpenseBalanceSummaryStore();
  featureFlagStore = useFeatureFlagStore();

  formatCurrency = formatCurrency;

  pocBarChartSize = {
    height: 300,
    width: 300
  };

  barChartSize = {
    height: 220,
    width: 300
  };

  mounted () {
    this.hsaDailyBalanceStore.loadBalanceOnFile();
  }

  get cashBalance (): number {
    return this.hsaDailyBalanceStore.getInstantBalance.amount || this.hsaDailyBalanceStore.balanceOnFileAmount;
  }

  get cashExpenseDataLoaded () {
    return this.hsaDailyBalanceStore.balanceOnFileLoaded && this.expenseBalanceSummaryStore.isSummaryLoaded;
  }

  get generateKey () {
    return this.cashExpenseDataLoaded ? `${this.expenseBalanceSummaryStore.unreimbursed}${this.cashBalance}` : "none";
  }
}
